export default {
  uhOh: 'Uh Oh!',
  nothingToEat: 'It seems there\'s nothing to Eat!',
  alphabetical: 'Alphabetical',
  price: 'Price',
  popularity: 'Popularity',
  select: 'Select',
  orderBy: 'Order By',
  youOrderedThisDish: 'You ordered this dish',
  popularToday: 'This item is popular today!',
  notSavedYet: 'Not saved yet',
  timeLeft: 'Time left to make an order:',
  days: '0 days | 1 day | {count} days',
  successfullyOrdered: 'Sucessfully ordered.',
  successfullyClearedOrder: 'Succesfully cleared order.',
  noMoreOrders: 'No More Orders.',
  submitOrder: 'Submit your order?',
  unsavedChanges: 'You have changed your order, but did not confirm yet. Do you want to save your changes?',
  addAdditional: 'Add Additional Dish',
  noMoreDishes: 'Order seems big enough already 😊.',
  orderForSomeoneElse: 'Modify other users\' order',
  modifyUserOrder: ' Orders Editing',
  searchByName: 'Search for user by name',
  userNotFound: 'User not found.',
  userSelections: 'User Selections',
  cannotAddMoreThanOne: 'Cannot add more than one multiple selection dish.',
  addDish: 'Add Dish',
  dishes: 'Dishes',
  limitedAmount: 'This dish is limited to a total of {limit} orders.',
  customOrderSuccessful: 'Order successfully saved',
};
